import { render, staticRenderFns } from "./ShotFileShipments.vue?vue&type=template&id=49657bb9&scoped=true&"
import script from "./ShotFileShipments.vue?vue&type=script&lang=js&"
export * from "./ShotFileShipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49657bb9",
  null
  
)

export default component.exports